import ModalFormWarning from '../modal_form_warning';
import * as React from 'react';
export var EditWarning = function () { return (React.createElement(ModalFormWarning, { title: 'Warning', description: "\n      Orders that are scheduled or in progress will not be impacted by this edit.\n      Changes to this budget will go into effect immediately.\n    " })); };
export default EditWarning;
